import { render } from "./NewInstitutions.vue?vue&type=template&id=484cd556&scoped=true"
import script from "./NewInstitutions.vue?vue&type=script&lang=js"
export * from "./NewInstitutions.vue?vue&type=script&lang=js"

import "./NewInstitutions.vue?vue&type=style&index=0&id=484cd556&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-484cd556"]])

export default __exports__